import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {ReduxFormPriorityToggle} from 'shells/redux-form-fields/priority-toggle';

import {Field} from 'redux-form';

import {PipelineSelectSingle} from '../../core/form/fields';

import styles from './stageset-priority-fields.module.css';

type Props = {
    fieldKey: string;
    title: string;
    isRequired: boolean;
    validate: (...args: any) => any;
    hasPriorityField: boolean;
};

export function StagesetPriorityFields(props: Props) {
    const stagesetField = (
        <FormField
            key={props.fieldKey}
            innerId={props.fieldKey}
            label={props.title}
            isRequired={props.isRequired}
            // @ts-expect-error
            validate={props.validate}
        >
            <Field
                name={props.fieldKey}
                component={PipelineSelectSingle}
                autoFocus={false}
                isRequired={props.isRequired}
                includeAutoDistribute={true}
            />
        </FormField>
    );

    if (props.hasPriorityField) {
        const priorityToggle = (
            <Field key='priority' name='priority' component={ReduxFormPriorityToggle} />
        );

        return (
            <div className='flex'>
                <div className={styles['stageset']}>{stagesetField}</div>
                <div className={styles['priority']}>{priorityToggle}</div>
            </div>
        );
    } else {
        return stagesetField;
    }
}
